import SubscriptionRestartPage from './SubscriptionRestartPage';

export default SubscriptionRestartPage;
